module.exports = __webpack_public_path__ + "img/git-export.31d2711c.png";